import { render, staticRenderFns } from "./UpdatePlayInfo.vue?vue&type=template&id=5e504400&scoped=true"
import script from "./UpdatePlayInfo.vue?vue&type=script&lang=js"
export * from "./UpdatePlayInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdatePlayInfo.vue?vue&type=style&index=0&id=5e504400&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e504400",
  null
  
)

export default component.exports